'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _changeProvidersLearnMore = require('./changeProvidersLearnMore.scss');

var _changeProvidersLearnMore2 = _interopRequireDefault(_changeProvidersLearnMore);

var _BackCloseHeader = require('./BackCloseHeader.js');

var _BackCloseHeader2 = _interopRequireDefault(_BackCloseHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeProviderLearnMoreComponent = function (_Component) {
  (0, _inherits3.default)(ChangeProviderLearnMoreComponent, _Component);

  function ChangeProviderLearnMoreComponent() {
    (0, _classCallCheck3.default)(this, ChangeProviderLearnMoreComponent);
    return (0, _possibleConstructorReturn3.default)(this, (ChangeProviderLearnMoreComponent.__proto__ || (0, _getPrototypeOf2.default)(ChangeProviderLearnMoreComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChangeProviderLearnMoreComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          provider = _props.provider,
          onBack = _props.onBack,
          onClose = _props.onClose,
          t = _props.t;
      var appMarketId = provider.appMarketId;


      return _react2.default.createElement(
        'div',
        { className: _changeProvidersLearnMore2.default.container },
        _react2.default.createElement(_BackCloseHeader2.default, { onClose: onClose, onBack: onBack, t: t }),
        _react2.default.createElement(
          'div',
          { className: _changeProvidersLearnMore2.default.content },
          _react2.default.createElement('iframe', {
            src: 'https://www.wix.com/app-market/app-preview/' + appMarketId
          })
        )
      );
    }
  }]);
  return ChangeProviderLearnMoreComponent;
}(_react.Component);

ChangeProviderLearnMoreComponent.propTypes = {
  provider: _propTypes2.default.object,
  onBack: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  t: _propTypes2.default.object
};
exports.default = ChangeProviderLearnMoreComponent;